

import { Table } from "antd";
import { formatRupee } from "../../../../utils";

interface PricipalPaidProps {
  data: any[];
  loading: boolean;
}

const PricipalPaid = ({ data, loading }: PricipalPaidProps)    => {  
  const ALL_PRINCIPAL_PAID_BUCKETS = [
  "0–25%",
  "25–50%",
  "50–75%",
  "75–100%",
];
const createEmptyPrincipalPaidBucket = (bucketName: string) => ({
  bucketName,
  originalPrincipal: 0,
  osValue: 0,
  totalBorrowers: 0,
  min: 0,
  max: 0,
  average: 0,
  median: 0,
});
const normalizePrincipalPaidData = (data: any[] = []) => {
  const map = new Map(
    data.map(item => [item.bucketName, item])
  );

  return ALL_PRINCIPAL_PAID_BUCKETS.map(bucket =>
    map.get(bucket) || createEmptyPrincipalPaidBucket(bucket)
  );
};
  const normalizedData = normalizePrincipalPaidData(data);

const principalPaidTableColumn = [
   { title: "% Principal Paid", dataIndex: "bucketName", key: "bucketName", render: (value:any) => <span>{value  ?? "-"}</span>, },
   { title: "Original Principal", dataIndex: "originalPrincipal", key: "originalPrincipal" , render: (originalPrincipal:any) => <span>{formatRupee(originalPrincipal) || "-"}</span>,},
   { title: "Outstanding Value", dataIndex: "osValue", key: "osValue",render: (osValue:any) => <span>{formatRupee(osValue) || "-"}</span>,} ,
   { title: "Total Borrowers", dataIndex: "totalBorrowers", key: "totalBorrowers" },
   { title: "Min O/S", dataIndex: "min", key: "min",render: (min:any) => <span>{formatRupee(min) || "-"}</span> },
   { title: "Max O/S", dataIndex: "max", key: "max",render: (max:any) => <span>{formatRupee(max) || "-"}</span> },
   { title: "Average O/S", dataIndex: "average", key: "average",render: (average:any) => <span>{formatRupee(average) || "-"}</span> },
   { title: "Median O/S", dataIndex: "median", key: "median" ,render: (median:any) => <span>{formatRupee(median) || "-"}</span> },
];


  return (
 <div className="mt-10">
      <Table
        columns={principalPaidTableColumn}
        dataSource={normalizedData || []}
        loading={loading}
        size="middle"
        pagination={false}
        style={{ cursor: "pointer" }}
        rowKey={(record) => record.bucketName}
      />
         <div className="mt-4 text-sm text-gray-600">
        <strong>Abbreviations:</strong>
        <ul className="list-disc flex justify-between ml-6 mt-1">
          <li><strong>Min O/S</strong> – Minimum Outstanding</li>
          <li><strong>Max O/S</strong> – Maximum Outstanding</li>
          <li><strong>Average O/S</strong> – Average Outstanding</li>
          <li><strong>Median O/S</strong> – Median Outstanding</li>
        </ul>
      </div>
 </div>
  );
};

export default PricipalPaid;